<template>
    <v-card-title class="d-flex justify-space-between">
        <!-- LANDSCAPE DISPLAY -->
        <v-row
            v-if="screenProperties.isLandscape"
            no-gutters
        >
            <v-col :cols="prices.total ? 6 : 12">
                <div class="h3 plot-title">
                    {{ title }}
                    <Favorite
                        v-if="hasFavoriteCta"
                        :location="'title'"
                        :data="data"
                    />
                </div>
            </v-col>
            <v-col
                v-if="prices.total"
                cols="6"
                class="text-right price-section"
            >
                <span
                    class="global-nav price-text"
                    v-html="prices.total"
                />

                <span
                    v-if="prices.plot !== prices.total"
                    class="habiteo-body-3 d-block price-detail"
                    v-html="$t('utils.plot') + ' : ' + prices.plot"
                />

                <span
                    v-if="prices.annex && prices.plot !== prices.total"
                    class="habiteo-body-3 d-block price-detail"
                    v-html="$t('utils.annex') + ' : ' +prices.annex"
                />
            </v-col>
        </v-row>
        <!-- /LANDSCAPE DISPLAY -->

        <!-- PORTRAIT DISPLAY -->
        <v-row
            v-else
            no-gutters
        >
            <v-col :cols="prices.total ? 6 : 12">
                <span
                    class="h2 plot-title"
                    v-html="title"
                />
                <Favorite
                    v-if="hasFavoriteCta && type !== 'plot-grid'"
                    :location="'title'"
                    :data="data"
                />
            </v-col>

            <v-col
                v-if="prices.total"
                cols="6"
                class="text-right price-section"
            >
                <span
                    class="global-nav price-text"
                    v-html="prices.total"
                />
                <span
                    v-if="prices.plot !== prices.total"
                    class="habiteo-body-3 d-block price-detail"
                    v-html="$t('utils.plot') + ' : ' + prices.plot"
                />

                <span
                    v-if="prices.annex && prices.plot !== prices.total"
                    class="habiteo-body-3 d-block price-detail"
                    v-html="$t('utils.annex') + ' : ' + prices.annex"
                />
            </v-col>
        </v-row>
        <!-- /PORTRAIT DISPLAY -->
    </v-card-title>
</template>

<script>
    import Favorite from '@/components/plotInformation/components/Favorite';

    export default {
        name: 'MainTitle',
        components: {
            Favorite
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            screenProperties: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            },
            prices: {
                type: Object,
                required: false
            },
            title: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                disabledAvailabilities: [
                    4,
                    5
                ]
            }
        },
        computed: {
            hasFavoriteCta() {
                let availabilityObj = this.$props.data.details.filter(detail => detail.id === 'availability');
                let availabilityType = availabilityObj.length ? availabilityObj[0].type : null;
                switch (this.$props.type) {
                    case 'plot':
                        return !this.disabledAvailabilities.includes(availabilityType) && ((this.$props.screenProperties.isMediumScreen && this.$props.screenProperties.isLandscape) || (this.$props.screenProperties.isTinyScreen && this.$props.screenProperties.isLandscape));
                    default:
                        return false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .plot-title {
        word-break: normal;
    }

    .price-section {
        span {
            &.price-text {
                font-weight: 800;
            }
            &.price-detail {
                height: 20px;
                line-height: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plotInformation/components/MainTitle.vue